import React, { Component } from 'react';
import { getWellGuideData } from '@zocdoc/components/src/WellGuide/api/WellGuideStatus';
import { fetchUser } from './utils/fetchUser';
import { JanuaryWellness } from './JanuaryWellness';
import isMobileBreakpoint from '../../../utils/isMobileBreakpoint';

export class JanuaryWellnessWrapper extends Component {
    render() {
        return (
            <JanuaryWellness
                fetchUser={fetchUser}
                getWellGuideData={getWellGuideData}
                isMobile={isMobileBreakpoint()}
                {...this.props}
            />
        );
    }
}
